/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-09-04 10:24:12
 */

import getUA from './getUA'

/* eslint-disable */
export default function generateFullUrl(config) {
  let fullUrl = ''
  if (config.url) {
    fullUrl = config.url
  } else {
    fullUrl = __API_SERVER_HOST__ + config.requestPath
  }

  if (config.parameter) {
    let paramsString = ''
    for (let i in config.parameter) {
      if (config.parameter[i] !== undefined && config.parameter[i] !== null) {
        paramsString += i + '=' + encodeURIComponent(config.parameter[i]) + '&'
      }
    }
    config.parameter = paramsString
  } else {
    config.parameter = ''
  }

  let splitKey = '?'
  if (fullUrl.indexOf('?') !== -1) {
    splitKey = '&'
  }
  fullUrl += config.parameter ? splitKey + config.parameter : ''

  return fullUrl
}
